<template>
  <div>
    <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <p class="hidden text-lg font-bold text-center pc:text-5xl text-neutral-950 mb-11 pc:block">회원가입</p>
      <div>
        <!-- <div class="mb-14 pc:mb-36" :style="signUser.userSignInfo.schoolLevel == '성인' ? 'margin-bottom:0px;' : ''"> -->
        <div class="mb-14 pc:mb-36">
          <p class="mb-5 text-lg font-bold pc:text-2xl text-neutral-950 pc:mb-4">회원 정보 : 기본정보</p>
          <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">회원 이름<br class="pc:hidden" />(실명)</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="text"
                  placeholder="회원 이름"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model.trim="signUser.userSignInfo.kname"
                  @blur="signUser.validateKname"
                />
                <p class="text-xs pc:text-base text-neutral-500">* 실제로 수업을 수강하실 학습자 기준으로 작성 바랍니다.</p>
              </div>
            </li>

            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">성별<br class="pc:hidden" /></p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5">
                <ul class="mb-1 flex gap-2">
                  <li class="flex items-center gap-1">
                    <input v-model="signUser.userSignInfo.gender" type="radio" name="gender" id="male" value="M" />
                    <label for="male" class="block">남</label>
                  </li>
                  <li class="flex items-center gap-1">
                    <input v-model="signUser.userSignInfo.gender" type="radio" name="gender" id="female" value="F" />
                    <label for="female" class="block">여</label>
                  </li>
                </ul>
                <p class="text-xs pc:text-base text-neutral-500">* 실제로 수업 받을 학습자 성별을 선택해 주세요.</p>
              </div>
            </li>

            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">이메일 주소</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5">
                <div class="flex flex-col gap-2.5">
                  <div class="flex flex-col gap-2.5 pc:flex-row">
                    <div class="relative pc:w-80">
                      <input
                        type="text"
                        placeholder="email@domain.com"
                        class="w-full p-4 text-xs border border-solid rounded border-neutral-200 placeholder:text-neutral-200 pc:text-base"
                        v-model.trim="signUser.userSignInfo.email"
                        @input="signUser.onEmailInput"
                        @keydown="signUser.onEmailKeydown"
                        @blur="signUser.closeEmailSuggest"
                        autocomplete="off"
                      />
                      <ul
                        v-if="signUser.emailSuggestOpen && signUser.emailSuggestList.length"
                        class="absolute left-0 right-0 z-10 mt-1 overflow-auto bg-white border border-solid rounded shadow border-neutral-200 max-h-48"
                      >
                        <li
                          v-for="(domain, i) in signUser.emailSuggestList"
                          :key="domain"
                          class="px-4 py-2 text-xs cursor-pointer pc:text-base"
                          :class="i === signUser.emailSuggestIndex ? 'bg-neutral-100' : ''"
                          @mousedown.prevent="signUser.selectEmailDomain(domain)"
                          @mouseenter="signUser.emailSuggestIndex = i"
                        >
                          {{ signUser.emailLocalPart }}@{{ domain }}
                        </li>
                      </ul>
                    </div>
                    <p
                      class="p-4 text-xs text-center border border-solid rounded cursor-pointer border-neutral-200 pc:text-base"
                      :class="
                        signUser.emailCheck === 'available'
                          ? 'bg-neutral-50 text-neutral-500'
                          : signUser.emailCheck === 'invalid' || signUser.emailCheck === 'duplicate'
                          ? 'bg-rose-600 text-white'
                          : 'bg-neutral-600 text-white'
                      "
                      @click="signUser.getUserEmailCheck"
                    >
                      중복확인
                    </p>
                  </div>
                  <p v-if="signUser.emailCheck === 'available'" class="text-xs font-bold text-purple-600 pc:text-base">
                    사용 가능한 이메일입니다.
                  </p>
                  <p v-if="signUser.emailCheck === 'invalid'" class="text-xs font-bold pc:text-base text-rose-600">
                    사용 불가능한 이메일입니다.
                  </p>
                  <p v-if="signUser.emailCheck === 'duplicate'" class="text-xs font-bold pc:text-base text-rose-600">
                    이미 사용중인 이메일입니다.
                  </p>
                </div>
                <p class="flex-none text-xs pc:text-base text-neutral-500">
                  * 입력해주신 이메일주소는 로그인 시 ID로 사용되므로, 정확히 입력 바랍니다.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">비밀번호</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="password"
                  placeholder="비밀번호"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.password"
                  @input="signUser.checkPasswordMatch"
                  autocomplete="new-password"
                />
                <p class="text-xs pc:text-base text-neutral-500">
                  * 영문 대/소문자, 숫자, 특수문자를 포함한 8자 이상 입력하세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">비밀번호 확인</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <div class="flex flex-col gap-2.5">
                  <input
                    type="password"
                    placeholder="비밀번호"
                    class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                    v-model="signUser.userSignInfo.passwordCheck"
                    @input="signUser.checkPasswordMatch"
                  />
                  <p
                    class="text-xs font-bold pc:text-base"
                    :class="signUser.passwordMatch && signUser.isPasswordCheckValid ? 'text-purple-600' : 'text-rose-600'"
                    v-if="signUser.showPasswordMessage"
                  >
                    {{
                      signUser.passwordMatch
                        ? signUser.isPasswordCheckValid
                          ? "* 두 비밀번호가 동일합니다."
                          : "* 비밀번호가 유효하지 않습니다."
                        : "* 두 비밀번호가 다릅니다."
                    }}
                  </p>
                </div>
                <p class="text-xs pc:text-base text-neutral-500">
                  * 영문 대/소문자, 숫자, 특수문자를 포함한 8자 이상 입력하세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">
                  영어이름<br class="pc:hidden" />(수업 이름)
                </p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="text"
                  placeholder="영어이름"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model.trim="signUser.userSignInfo.ename"
                  @input="signUser.convertToLowerCase"
                />
                <p class="text-xs pc:text-base text-neutral-500">* 수업에서 사용되는 이름입니다.</p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">휴대전화</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="tel"
                  placeholder="010-1234-5678"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.mobile"
                  @input="signUser.formatMobile"
                />
                <ul>
                  <li class="text-xs pc:text-base text-neutral-500">
                    * 모든 안내문자와 연락에 사용되는 전화번호입니다. 정확히 기재 바랍니다.
                  </li>
                  <li class="text-xs pc:text-base text-neutral-500">* 휴대폰이 없는 경우, 학부모님 연락처로 기입 바랍니다.</li>
                  <li class="text-xs pc:text-base text-neutral-500">
                    * 모든 안내를 학부모님 번호로 받기 희망하시면 학부모님 번호로 기재 바랍니다.
                  </li>
                </ul>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">생년월일</p>
              </div>
              <div>
                <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.year"
                    >
                      <option v-for="year in signUser.userSignInfo.years" :key="year">{{ year }}</option>
                    </select>
                    <p>년</p>
                  </div>
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.month"
                    >
                      <option v-for="month in signUser.userSignInfo.months" :key="month">{{ month }}</option>
                    </select>
                    <p>월</p>
                  </div>
                  <div class="flex gap-2.5 items-center">
                    <select
                      type="text"
                      class="w-32 p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model="signUser.userSignInfo.day"
                    >
                      <option v-for="day in signUser.userSignInfo.days" :key="day">{{ day }}</option>
                    </select>
                    <p>일</p>
                  </div>
                </div>
                <p class="pl-2.5 pb-3 pc:pl-9 pc:pb-4 text-xs pc:text-base text-neutral-500">
                  * 학습자의 생년월일을 입력해 주세요.
                </p>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">학교 레벨</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <select
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.schoolLevel"
                >
                  <option value="">선택해주세요</option>
                  <template v-if="route.query.type === 'adult'">
                    <option value="중학교">중학교</option>
                    <option value="고등학교">고등학교</option>
                    <option value="성인">성인</option>
                  </template>
                  <template v-else>
                    <option value="미취학">미취학</option>
                    <option value="초등학교">초등학교</option>
                    <option value="중학교">중학교</option>
                  </template>
                </select>
              </div>
            </li>
            <li
              v-if="signUser.userSignInfo.schoolLevel !== '미취학' && signUser.userSignInfo.schoolLevel !== '성인'"
              class="flex items-center"
            >
              <div
                v-if="signUser.userSignInfo.schoolLevel !== ''"
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">학교/학년/반</p>
              </div>
              <div
                v-if="signUser.userSignInfo.schoolLevel === '초등학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="초등학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model.trim="signUser.userSignInfo.schoolName"
                      @blur="signUser.validateSchoolName"
                    />
                    <p>초등학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolGrade"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolClass"
                      @input="signUser.onInputSchoolClassNumberOnly"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
              <div
                v-if="signUser.userSignInfo.schoolLevel === '중학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="중학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model.trim="signUser.userSignInfo.schoolName"
                      @blur="signUser.validateSchoolName"
                    />
                    <p>중학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolGrade"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolClass"
                      @input="signUser.onInputSchoolClassNumberOnly"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
              <div
                v-if="signUser.userSignInfo.schoolLevel === '고등학교'"
                class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center"
              >
                <ul class="flex flex-col pc:flex-row gap-2.5 pc:gap-9">
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="고등학교"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200"
                      v-model.trim="signUser.userSignInfo.schoolName"
                      @blur="signUser.validateSchoolName"
                    />
                    <p>고등학교</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="학년"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolGrade"
                      @input="signUser.onInputNumberOnly"
                    />
                    <p>학년</p>
                  </li>
                  <li class="flex items-center gap-2.5">
                    <input
                      type="text"
                      placeholder="반"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-20"
                      v-model="signUser.userSignInfo.schoolClass"
                      @input="signUser.onInputSchoolClassNumberOnly"
                    />
                    <p>반</p>
                  </li>
                </ul>
              </div>
            </li>
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">주소</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <ul class="flex flex-col gap-2">
                  <li class="flex gap-2">
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model="signUser.userSignInfo.postcode"
                      readonly
                      @click="signUser.execDaumPostcode"
                    />
                    <p
                      class="flex-none p-4 text-xs border border-solid rounded cursor-pointer pc:text-base text-neutral-500 bg-neutral-50 border-neutral-200"
                      @click="signUser.execDaumPostcode"
                    >
                      우편번호 찾기
                    </p>
                  </li>
                  <li>
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model="signUser.userSignInfo.address"
                      readonly
                      @click="signUser.execDaumPostcode"
                    />
                  </li>
                  <li>
                    <input
                      type="text"
                      class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                      v-model.trim="signUser.userSignInfo.addressSub"
                    />
                  </li>
                </ul>
              </div>
            </li>
            <!-- 사회적배려대상자 / 레벨테스트 진행 항목 제거: 회원가입에서 더 이상 수집하지 않음 -->
          </ul>
        </div>

        <div v-if="route.query.type === 'minor' || (route.query.type === 'adult' && (signUser.userSignInfo.schoolLevel === '중학교' || signUser.userSignInfo.schoolLevel === '고등학교'))" class="mb-7 pc:mb-24">
          <p class="mb-5 text-lg font-bold pc:text-2xl text-neutral-950 pc:mb-4">
            학부모 정보
            <span class="text-orange-600">(※주니어 학습자인 경우에만 입력해주세요.)</span>
          </p>
          <ul class="grid grid-cols-1 border-t border-b border-solid divide-y border-neutral-950 divide-solid divide-neutral-200">
            <li class="flex items-center">
              <div
                class="flex-none w-24 pc:w-60 px-2.5 py-3 pc:px-9 pc:py-4 self-stretch flex justify-center items-center bg-neutral-50"
              >
                <p class="text-sm font-bold text-center text-neutral-950 pc:text-lg">휴대전화</p>
              </div>
              <div class="grow pl-2.5 py-3 pc:pl-9 pc:py-4 flex flex-col gap-2.5 pc:flex-row pc:gap-9 pc:items-center">
                <input
                  type="tel"
                  placeholder="010-1234-5678"
                  class="p-4 text-xs border border-solid rounded pc:text-base border-neutral-200 placeholder:text-neutral-200 pc:w-80"
                  v-model="signUser.userSignInfo.parentMobile"
                  @input="signUser.formatParentMobile"
                />
                <ul>
                  <li class="text-xs pc:text-base text-neutral-500">
                    * 모든 안내문자와 연락에 사용되는 전화번호입니다. 정확히 기재 바랍니다.
                  </li>
                  <li class="text-xs pc:text-base text-neutral-500">* 휴대폰이 없는 경우, 학부모님 연락처로 기입 바랍니다.</li>
                  <li class="text-xs pc:text-base text-neutral-500">
                    * 모든 안내를 학부모님 번호로 받기 희망하시면 학부모님 번호로 기재 바랍니다.
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <p
          class="max-w-xs py-4 mx-auto text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:py-6 pc:text-xl"
          @click="signUser.signRegister"
        >
          회원가입
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import { reactive, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain;
    const idxCompany = store.getters.getIdxCompany;

    // 이메일 도메인 자동완성 후보
    const EMAIL_DOMAINS = [
      "naver.com",
      "gmail.com",
      "daum.net",
      "hanmail.net",
      "kakao.com",
      "nate.com",
      "hotmail.com",
      "outlook.com",
      "icloud.com",
      "yahoo.com",
    ];

    const signUser = reactive({
      userSignInfo: {
        address: "", // 주소
        addressSub: "", // 상세 주소
        birthday: computed(() => `${signUser.userSignInfo.year}${signUser.userSignInfo.month}${signUser.userSignInfo.day}`),
        ename: "", // 영어 이름
        email: "", // 이메일 (email@domain.com 전체)
        idxMember: "",
        kname: "", // 한글 이름
        mobile: "", // 휴대폰 번호
        parentMobile: "", // 부모님 휴대폰 번호 (학부모 정보는 휴대전화만 수집)
        password: "", // 비밀번호
        passwordCheck: "", // 비밀번호 확인
        postcode: "", // 우편번호
        schoolLevel: "", // 학교 레벨
        year: "",
        month: "",
        day: "",
        schoolName: "",
        schoolGrade: "",
        schoolClass: "",
        years: Array.from({ length: 105 }, (_, i) => 1920 + i),
        months: Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0")),
        days: Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, "0")),
        gender: "", // 성별
      },

      passwordMatch: false,
      showPasswordMessage: false,

      emailCheck: null,

      // 이메일 도메인 자동완성 상태
      emailSuggestOpen: false,
      emailSuggestList: [],
      emailSuggestIndex: 0,
      emailLocalPart: "",

      isPasswordCheckValid: false,

      onInputNumberOnly(event) {
        // 숫자 이외의 값 제거
        let value = event.target.value.replace(/[^1-9]/g, "");
        const intValue = parseInt(value, 10);
        if (intValue >= 1 && intValue <= 9) {
          event.target.value = intValue.toString();
        } else {
          event.target.value = "";
        }
      },

      onInputSchoolClassNumberOnly(event) {
        event.target.value = event.target.value.replace(/[^가-힣a-zA-Z0-9]/g, "");
      },

      // restrictInput() {
      //   signUser.userSignInfo.schoolName = signUser.userSignInfo.schoolName.replace(/[^\w가-힣]/g, "");
      // },

      validateSchoolName() {
        const koreanRegex = /^[가-힣]+$/;
        const originalName = signUser.userSignInfo.schoolName; // 원래의 학교 이름 저장

        if (!koreanRegex.test(originalName)) {
          const filteredName = originalName.replace(/[^가-힣]/g, "");
          signUser.userSignInfo.schoolName = filteredName; // 필터링된 이름을 저장

          // 원래 이름과 필터링된 이름이 다르면 경고창 표시
          if (originalName !== filteredName) {
            alert("한글만 입력해주세요.");
          }
        }
      },
      // validateKoreanInput() {
      //   const koreanRegex = /^[가-힣]*$/;

      //   if (!koreanRegex.test(signUser.userSignInfo.kname) || /\s/.test(signUser.userSignInfo.kname)) {
      //     alert("한글만 입력해주세요.");
      //     signUser.userSignInfo.kname = signUser.userSignInfo.kname.replace(/[^가-힣]/g, "");
      //   }

      //   if (!koreanRegex.test(signUser.userSignInfo.kname)) {
      //     signUser.userSignInfo.kname = signUser.userSignInfo.kname.replace(/[^가-힣]/g, "");

      //     alert("한글만 입력해주세요.");
      //   }
      // },

      validateKname() {
        const koreanRegex = /^[가-힣]+$/;

        if (!koreanRegex.test(signUser.userSignInfo.kname)) {
          signUser.userSignInfo.kname = signUser.userSignInfo.kname.replace(/[^가-힣]/g, "");

          alert("한글만 입력해주세요.");
        }
      },

      // 이메일 한 칸 입력 처리: 소문자·허용문자만 남기고 도메인 자동완성 후보를 갱신한다.
      onEmailInput() {
        const value = signUser.userSignInfo.email.toLowerCase().replace(/[^a-z0-9._%+@-]/g, "");
        signUser.userSignInfo.email = value;
        // 이메일이 바뀌면 이전 중복확인 결과는 무효화한다. (다시 중복확인 필요)
        signUser.emailCheck = null;

        const at = value.indexOf("@");
        if (at === -1) {
          signUser.emailSuggestOpen = false;
          signUser.emailSuggestList = [];
          return;
        }
        const local = value.slice(0, at);
        const domainPart = value.slice(at + 1);
        signUser.emailLocalPart = local;
        signUser.emailSuggestList = domainPart === "" ? EMAIL_DOMAINS.slice() : EMAIL_DOMAINS.filter((d) => d.startsWith(domainPart));
        // 로컬파트가 있고 후보가 있을 때만 노출한다. (이미 완성된 도메인 하나만 남으면 숨김)
        const alreadyComplete = signUser.emailSuggestList.length === 1 && signUser.emailSuggestList[0] === domainPart;
        signUser.emailSuggestOpen = local !== "" && signUser.emailSuggestList.length > 0 && !alreadyComplete;
        signUser.emailSuggestIndex = 0;
      },

      // 후보 도메인을 선택해 이메일을 완성한다.
      selectEmailDomain(domain) {
        signUser.userSignInfo.email = `${signUser.emailLocalPart}@${domain}`;
        signUser.emailSuggestOpen = false;
        signUser.emailSuggestList = [];
        signUser.emailCheck = null;
      },

      // 자동완성 목록 키보드 조작 (↑ ↓ Enter Esc)
      onEmailKeydown(event) {
        if (!signUser.emailSuggestOpen || !signUser.emailSuggestList.length) return;
        if (event.key === "ArrowDown") {
          event.preventDefault();
          signUser.emailSuggestIndex = (signUser.emailSuggestIndex + 1) % signUser.emailSuggestList.length;
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          signUser.emailSuggestIndex =
            (signUser.emailSuggestIndex - 1 + signUser.emailSuggestList.length) % signUser.emailSuggestList.length;
        } else if (event.key === "Enter") {
          event.preventDefault();
          signUser.selectEmailDomain(signUser.emailSuggestList[signUser.emailSuggestIndex]);
        } else if (event.key === "Escape") {
          signUser.emailSuggestOpen = false;
        }
      },

      // 포커스가 빠지면 자동완성 목록을 닫는다. (후보 클릭 처리 후 닫히도록 약간 지연)
      closeEmailSuggest() {
        setTimeout(() => {
          signUser.emailSuggestOpen = false;
        }, 150);
      },

      // 이메일 형식 검증 (email@domain.com)
      isValidEmail(email) {
        return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(email);
      },

      checkPasswordMatch() {
        signUser.passwordMatch = signUser.userSignInfo.password === signUser.userSignInfo.passwordCheck;

        const passwordRegex = /^(?=.*\d)(?=.*[~`!@#$%\^&*()-])(?=.*[a-zA-Z]).{8,15}$/;
        const isPasswordCheckValid = passwordRegex.test(signUser.userSignInfo.passwordCheck);

        signUser.showPasswordMessage =
          signUser.userSignInfo.password.length > 0 || signUser.userSignInfo.passwordCheck.length > 0;
        this.isPasswordCheckValid = isPasswordCheckValid;
      },

      convertToLowerCase() {
        const input = signUser.userSignInfo.ename;

        if (/[ㄱ-ㅎㅏ-ㅣ가-힣\d]/.test(input)) {
          alert("영어 이름은 영어만 입력 가능합니다.");
          signUser.userSignInfo.ename = input.replace(/[^a-zA-Z]/g, "");
        } else {
          signUser.userSignInfo.ename = input.toLowerCase();
        }
      },

      formatMobile() {
        let input = signUser.userSignInfo.mobile;

        // 정규식을 사용하여 숫자만 추출
        let numericValue = input.replace(/\D/g, "");

        // 하이픈 추가
        let formattedValue = numericValue.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");

        // 최대 길이를 초과하지 않도록 조정
        signUser.userSignInfo.mobile = formattedValue.slice(0, 13);
      },

      formatParentMobile() {
        let input = signUser.userSignInfo.parentMobile;
        // 정규식을 사용하여 숫자만 추출
        let numericValue = input.replace(/\D/g, "");
        // 하이픈 추가
        let formattedValue = numericValue.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        // 최대 길이를 초과하지 않도록 조정
        signUser.userSignInfo.parentMobile = formattedValue.slice(0, 13);
      },

      execDaumPostcode() {
        new window.daum.Postcode({
          oncomplete: (data) => {
            signUser.userSignInfo.postcode = data.zonecode;
            let buildingName = data.buildingName ? ` (${data.buildingName})` : "";
            signUser.userSignInfo.address = data.roadAddress + buildingName;
            // signUser.userSignInfo.addressSub = data.jibunAddress;
          },
        }).open();
      },

      signRegister() {
        if (!signUser.userSignInfo.kname) {
          alert("회원 이름을 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.gender) {
          alert("성별을 선택해주세요.");
          return;
        }

        if (!signUser.userSignInfo.email) {
          alert("이메일을 입력해주세요.");
          return;
        }

        if (!signUser.isValidEmail(signUser.userSignInfo.email)) {
          alert("이메일 형식이 올바르지 않습니다.");
          return;
        }

        if (signUser.emailCheck !== "available") {
          alert("사용 가능한 이메일인지 확인해주세요.");
          return;
        }

        if (!signUser.userSignInfo.password) {
          alert("비밀번호를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.passwordCheck) {
          alert("비밀번호를 확인해주세요.");
          return;
        }

        if (!signUser.userSignInfo.ename) {
          alert("영어이름을 입력해주세요");
          return;
        }

        if (!signUser.userSignInfo.mobile) {
          alert("휴대전화 번호를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.birthday) {
          alert("생년월일을 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.schoolLevel) {
          alert("학교 레벨을 선택해주세요");
          return;
        }

        // if (
        //   signUser.userSignInfo.schoolLevel !== "미취학" &&
        //   signUser.userSignInfo.schoolLevel !== "성인" &&
        //   !signUser.userSignInfo.schoolInfo
        // ) {
        //   alert("학교정보를 입력해주세요.");
        //   return;
        // }

        // 사업부 요청(2026-07-13): 우편번호/주소/상세주소를 모두 필수값으로 강제.
        // 우편번호·주소는 "우편번호 찾기"(다음 우편번호 API)로 함께 채워지고,
        // 상세주소만 사용자가 직접 입력한다. 프론트에서만 막고 백엔드 검증은 그대로 둔다.
        if (!signUser.userSignInfo.postcode || !signUser.userSignInfo.address) {
          alert("우편번호 찾기를 통해 주소를 입력해주세요.");
          return;
        }

        if (!signUser.userSignInfo.addressSub) {
          alert("상세주소를 입력해주세요.");
          return;
        }

        const mobileRegex = /^010-\d{3,4}-\d{4}$/;
        if (!mobileRegex.test(signUser.userSignInfo.mobile)) {
          alert("휴대폰 번호를 다시 확인해주세요.");
          return;
        }

        const params = {
          ...signUser.userSignInfo,
          idxCompany: idxCompany,
        };

        // 학부모 정보는 휴대전화(parentMobile)만 수집한다.
        // 학부모 이름/이메일 입력은 제거되었으므로 페이로드에서도 함께 제외한다.
        // (백엔드 UserRegisterDTO는 parentName/parentEmail을 nullable로 받으므로 미전송해도 무방)
        delete params.parentName;
        delete params.parentEmail;
        delete params.parentSelectEmail;
        delete params.parentinputEmail;
        axios.post(`/user/auth/register`, params, {}).then(function (res) {
          if (res.data.success === true) {
            router.push({
              path: "/signUp/signUpOk",
            });
          } else {
            alert(res.data.message);
          }
        });
      },

      // 중복확인 버튼: 형식 검사 후 백엔드 중복 여부를 조회한다.
      getUserEmailCheck() {
        const email = signUser.userSignInfo.email;

        if (!email) {
          alert("이메일을 입력해주세요.");
          return;
        }

        // 형식이 올바르지 않으면 조회하지 않고 "사용 불가능" 처리한다.
        if (!signUser.isValidEmail(email)) {
          signUser.emailCheck = "invalid";
          return;
        }

        axios.get(`/user/auth/getUserEmailCheck`, { params: { email } }).then(function (res) {
          if (res.data.success === true) {
            signUser.emailCheck = "available";
          } else {
            signUser.emailCheck = "duplicate";
          }
        });
      },
    });

    onMounted(() => {});

    return {
      signUser,
      idxLeSiteMain,
      idxCompany,
      route,
    };
  },
};
</script>
<style scoped>
input[type="radio"] {
  -webkit-appearance: auto;
  -moz-appearance: auto;
  appearance: auto;
}
</style>
